var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { computed, set } from '@ember/object';
import { readOnly, not, and, or, bool, equal } from '@ember/object/computed';
import TrackRelationships from 'ember-data-relationship-tracker';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { isValidPasscode } from '@square/dashboard-data/utils/employees/passcode';
import { TeamMember } from '@square/dashboard-protos/models/squareup/team_api/resources/datatypes';
import { A } from '@ember/array';
import { tracked } from '@glimmer/tracking';
export const MAX_NAME_LENGTH = 255;
export const MAX_EMPLOYEE_NUMBER_LENGTH = 255;
const InvitationStatus = TeamMember.InvitationStatus;
let Employee = (_dec = readOnly('id'), _dec2 = attr('boolean', {
  defaultValue: true
}), _dec3 = attr('object-transform'), _dec4 = attr('string'), _dec5 = belongsTo('employee-role', {
  async: false,
  inverse: 'employees'
}), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = hasMany('merchant-subunit-ed', {
  async: false,
  inverse: null
}), _dec13 = attr('boolean', {
  readOnly: true
}), _dec14 = attr('string'), _dec15 = attr('boolean', {
  defaultValue: true,
  readOnly: true
}), _dec16 = attr('boolean', {
  defaultValue: false
}), _dec17 = attr('boolean'), _dec18 = attr('number'), _dec19 = attr('number'), _dec20 = attr('array', {
  defaultValue: () => A([])
}), _dec21 = attr('boolean', {
  defaultValue: false
}), _dec22 = attr('string'), _dec23 = attr('object-transform', {
  defaultValue: () => {}
}), _dec24 = attr('string'), _dec25 = attr('object-transform', {
  defaultValue: () => {}
}), _dec26 = attr('array', {
  defaultValue: () => A([])
}), _dec27 = and('canBeInvitedOrReinvited', '_needsAutoInviteToLogin'), _dec28 = or('hasNotBeenInvited', 'emailIsChanged'), _dec29 = not('isAccountOwner'), _dec30 = bool('employeeRole.isOwnerRole'), _dec31 = not('isOwner'), _dec32 = bool('employeeRole.isAdminRole'), _dec33 = bool('employeeRole.isFreeRole'), _dec34 = bool('employeeRole.isPaidRole'), _dec35 = and('employeeRole.canEmployeesAccessRegisterWithPasscode', 'isNotAccountOwner'), _dec36 = not('hasPasscode'), _dec37 = or('hasPasscode', 'hasPasscodeRole'), _dec38 = computed('merchantSuppliedEmail', function () {
  return Boolean(this.changedAttributes()['merchantSuppliedEmail']);
}), _dec39 = not('emailIsChanged'), _dec40 = computed('passcode.length', function () {
  return isValidPasscode(this.passcode);
}), _dec41 = readOnly('hasDirtyFields'), _dec42 = not('isDirty'), _dec43 = readOnly('merchantSuppliedEmail'), _dec44 = computed('employeeRole.canInviteToLogin', 'email', 'isAccountOwner', function () {
  if (!this.employeeRole || this.isAccountOwner) {
    return false;
  }
  return this.employeeRole.canInviteToLogin && !this.email;
}), _dec45 = computed('employeeRole.canEmployeesAccessRegisterWithPasscode', 'hasPasscode', 'isAccountOwner', function () {
  if (!this.employeeRole || this.isAccountOwner) {
    return false;
  }
  return this.employeeRole.canEmployeesAccessRegisterWithPasscode && !this.hasPasscode;
}), _dec46 = computed('units.length', 'canAccessAllUnits', function () {
  return this.units.length === 0 && !this.canAccessAllUnits;
}), _dec47 = computed('active', 'isMissingRequiredEmail', 'isMissingRequiredPasscode', 'belongsToNoUnits', 'employeeRole', function () {
  if (!this.active) {
    return false;
  }
  if (this.isMissingRequiredEmail || this.isMissingRequiredPasscode) {
    return true;
  }
  if (this.belongsToNoUnits) {
    return Boolean(this.employeeRole);
  }
  return false;
}), _dec48 = equal('invitationStatus', InvitationStatus.ACCEPTED), _dec49 = equal('invitationStatus', InvitationStatus.PENDING), _dec50 = equal('invitationStatus', InvitationStatus.UNINVITED), _dec51 = equal('invitationStatus', InvitationStatus.EXPIRED), _dec52 = not('hasAcceptedInvitation'), _dec53 = equal('inviteEligibilityStatus', TeamMember.InviteEligibilityStatus.ELIGIBLE), _dec54 = and('active', 'employeeRole', 'merchantSuppliedEmail', 'hasNotAcceptedInvitation'), (_class = (_class2 = class Employee extends EmberDataBaseModel.extend(TrackRelationships) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "token", _descriptor, this);
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor2, this);
    _initializerDefineProperty(this, "active", _descriptor3, this);
    _initializerDefineProperty(this, "badgePairing", _descriptor4, this);
    _initializerDefineProperty(this, "employeeNumber", _descriptor5, this);
    _initializerDefineProperty(this, "employeeRole", _descriptor6, this);
    _initializerDefineProperty(this, "permissionSetId", _descriptor7, this);
    _initializerDefineProperty(this, "firstName", _descriptor8, this);
    _initializerDefineProperty(this, "lastName", _descriptor9, this);
    _initializerDefineProperty(this, "initials", _descriptor10, this);
    _initializerDefineProperty(this, "merchantSuppliedEmail", _descriptor11, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor12, this);
    _initializerDefineProperty(this, "units", _descriptor13, this);
    _initializerDefineProperty(this, "hasPasscode", _descriptor14, this);
    // Passcode will not be sent by Team API. It must be set separately.
    _initializerDefineProperty(this, "passcode", _descriptor15, this);
    _initializerDefineProperty(this, "canBeManaged", _descriptor16, this);
    _initializerDefineProperty(this, "isAuthorizedUser", _descriptor17, this);
    _initializerDefineProperty(this, "canAccessAllUnits", _descriptor18, this);
    _initializerDefineProperty(this, "invitationStatus", _descriptor19, this);
    _initializerDefineProperty(this, "inviteEligibilityStatus", _descriptor20, this);
    _initializerDefineProperty(this, "jobTemplateIds", _descriptor21, this);
    _initializerDefineProperty(this, "isAccountOwner", _descriptor22, this);
    _initializerDefineProperty(this, "personId", _descriptor23, this);
    _initializerDefineProperty(this, "associatedProducts", _descriptor24, this);
    _initializerDefineProperty(this, "birthDate", _descriptor25, this);
    _initializerDefineProperty(this, "address", _descriptor26, this);
    _initializerDefineProperty(this, "complianceRequiredFields", _descriptor27, this);
    _initializerDefineProperty(this, "isPasscodeTaken", _descriptor28, this);
    _initializerDefineProperty(this, "willBeInvited", _descriptor29, this);
    _initializerDefineProperty(this, "_needsAutoInviteToLogin", _descriptor30, this);
    _initializerDefineProperty(this, "isNotAccountOwner", _descriptor31, this);
    _initializerDefineProperty(this, "isOwner", _descriptor32, this);
    _initializerDefineProperty(this, "isNotOwner", _descriptor33, this);
    _initializerDefineProperty(this, "isAdmin", _descriptor34, this);
    _initializerDefineProperty(this, "hasFreeRole", _descriptor35, this);
    _initializerDefineProperty(this, "hasPaidRole", _descriptor36, this);
    _initializerDefineProperty(this, "hasPasscodeRole", _descriptor37, this);
    _initializerDefineProperty(this, "doesNotHavePasscode", _descriptor38, this);
    _initializerDefineProperty(this, "requiresPasscode", _descriptor39, this);
    _initializerDefineProperty(this, "emailIsChanged", _descriptor40, this);
    _initializerDefineProperty(this, "emailIsUnchanged", _descriptor41, this);
    _initializerDefineProperty(this, "hasValidPasscode", _descriptor42, this);
    _initializerDefineProperty(this, "isDirty", _descriptor43, this);
    _initializerDefineProperty(this, "isClean", _descriptor44, this);
    _initializerDefineProperty(this, "email", _descriptor45, this);
    _initializerDefineProperty(this, "isMissingRequiredEmail", _descriptor46, this);
    _initializerDefineProperty(this, "isMissingRequiredPasscode", _descriptor47, this);
    _initializerDefineProperty(this, "belongsToNoUnits", _descriptor48, this);
    _initializerDefineProperty(this, "isIncomplete", _descriptor49, this);
    _initializerDefineProperty(this, "hasAcceptedInvitation", _descriptor50, this);
    _initializerDefineProperty(this, "hasInvitationPending", _descriptor51, this);
    _initializerDefineProperty(this, "hasNotBeenInvited", _descriptor52, this);
    _initializerDefineProperty(this, "invitationHasExpired", _descriptor53, this);
    _initializerDefineProperty(this, "hasNotAcceptedInvitation", _descriptor54, this);
    _initializerDefineProperty(this, "isInviteEligible", _descriptor55, this);
    _initializerDefineProperty(this, "canBeInvitedOrReinvited", _descriptor56, this);
  }
  // If employeeRole is set directly, then it does not dirty the model.
  watchAndSetRole(role) {
    this.watchRelationship('employeeRole', () => set(this, 'employeeRole', role));
  }

  // If units is set directly, then it does not dirty the model.
  watchAndSetUnits(units) {
    this.watchRelationship('units', () => set(this, 'units', units));
  }
  setJobTemplateIds(jobTemplateIds) {
    // Temporary hack until we move the Employee model into @dashboard/employees.
    // This section ensures that the legacy Dashboard app will refresh its UI
    // when jobTemplateIds is updated.
    this.jobTemplateIds.clear();
    this.jobTemplateIds.pushObjects(A([...jobTemplateIds]));
    set(this, 'jobTemplateIds', this.jobTemplateIds);
  }
  belongsToSomeUnits(units) {
    if (this.canAccessAllUnits) {
      return true;
    }
    const unitTokens = new Set(units.mapBy('token'));
    return this.units.any(unit => unitTokens.has(unit.token));
  }
  revert() {
    this.rollbackAttributes();
    this.rollbackRelationships();
    set(this, 'isPasscodeTaken', false);
  }
  async save(...args) {
    await super.save(...args);
    // The relationship tracker requires that we have a version field that changes when the model is saved.
    this.relationshipTrackerVersion++;
  }
  async forceClean() {
    await this.save({
      adapterOptions: {
        preventSave: true
      }
    });
  }
  async reactivate() {
    await this.save({
      adapterOptions: {
        activeOverride: true
      }
    });
  }
  async deactivate() {
    await this.save({
      adapterOptions: {
        activeOverride: false
      }
    });
  }
  async removePermissions() {
    await this.save({
      adapterOptions: {
        removePermissions: true
      }
    });
  }
  async saveWithAuthorizedUserStatus(isAuthorizedUserOverride) {
    await this.save({
      adapterOptions: {
        isAuthorizedUserOverride
      }
    });
  }
  async saveWithShouldSilenceInvitation(shouldSilenceInvitation) {
    await this.save({
      adapterOptions: {
        shouldSilenceInvitation
      }
    });
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'employee'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "token", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "relationshipTrackerVersion", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "badgePairing", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "employeeNumber", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "employeeRole", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "permissionSetId", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "firstName", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "lastName", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "initials", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "merchantSuppliedEmail", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "units", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "hasPasscode", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "passcode", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "canBeManaged", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "isAuthorizedUser", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "canAccessAllUnits", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "invitationStatus", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "inviteEligibilityStatus", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "jobTemplateIds", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "isAccountOwner", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "personId", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "associatedProducts", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "birthDate", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "address", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "complianceRequiredFields", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "isPasscodeTaken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "willBeInvited", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_needsAutoInviteToLogin", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "isNotAccountOwner", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "isOwner", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "isNotOwner", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "isAdmin", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "hasFreeRole", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "hasPaidRole", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "hasPasscodeRole", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "doesNotHavePasscode", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "requiresPasscode", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "emailIsChanged", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "emailIsUnchanged", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "hasValidPasscode", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "isClean", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "isMissingRequiredEmail", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "isMissingRequiredPasscode", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "belongsToNoUnits", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "isIncomplete", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "hasAcceptedInvitation", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "hasInvitationPending", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "hasNotBeenInvited", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "invitationHasExpired", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "hasNotAcceptedInvitation", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "isInviteEligible", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "canBeInvitedOrReinvited", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Employee as default };